/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/blocks/heading.scss';

const propTypes = {
    size: PropTypes.string,
    body: PropTypes.string.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    size: 'h1',
    className: null,
};

export const HeadingBlock = ({ body, size, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [styles[size]]: size !== null,
                [className]: className !== null,
            },
        ])}
    >
        <h4 className={styles.text} dangerouslySetInnerHTML={{ __html: body }} />
    </div>
);

HeadingBlock.propTypes = propTypes;
HeadingBlock.defaultProps = defaultProps;

export default HeadingBlock;
